import { useRequest } from 'liyu-pc-base/init-plugin';
import type { PageResult } from 'liyu-pc-base/api/typing';

export async function create_view_settings(params: Record<string, any>) {
  return useRequest().post('/view/create_view_settings', params);
}

export async function update_view_settings(params: Record<string, any>) {
  return useRequest().post('/view/update_view_settings', params);
}

export async function refresh_view_settings_cache(params: Record<string, any>) {
  return useRequest().post('/view/refresh_view_settings_cache', params);
}

export async function set_view_settings_default(params: Record<string, any>) {
  return useRequest().post('/view/set_view_settings_default', params);
}

export async function delete_view_settings(params: Record<string, any>) {
  return useRequest().post('/view/delete_view_settings', params);
}

export async function recover_view_settings(params: Record<string, any>) {
  return useRequest().post('/view/recover_view_settings', params);
}

export async function get_view_settings(params: Record<string, any>) {
  return useRequest().post('/view/get_view_settings', params);
}

export async function create_user_view(params: Record<string, any>) {
  return useRequest().post('/view/create_user_view', params);
}

export async function update_user_view(params: Record<string, any>) {
  return useRequest().post('/view/update_user_view', params);
}

export async function delete_user_view(params: Record<string, any>) {
  return useRequest().post('/view/delete_user_view', params);
}

export async function recover_user_view(params: Record<string, any>) {
  return useRequest().post('/view/recover_user_view', params);
}

export async function get_user_view(params: Record<string, any>) {
  return useRequest().post('/view/get_user_view', params);
}

export async function get_view_settings_for_user(params: Record<string, any>) {
  return useRequest().post('/view/get_view_settings_for_user', params);
}

export async function change_view_settings_sort(params: Record<string, any>) {
  return useRequest().post('/view/change_view_settings_sort', params);
}

export async function query_view_settings_list(params?: {
  [key: string]: any;
}): Promise<PageResult> {
  return useRequest().post('/view/query_view_settings_list', params);
}

export async function query_user_view_list(params?: { [key: string]: any }): Promise<PageResult> {
  return useRequest().post('/view/query_user_view_list', params);
}
